<template>
    <div>
        <Emargement v-if="['1','3'].includes($store.state.currentUser.user.autorisation)"></Emargement>
        <EmargementTrainer v-if="['2','3'].includes($store.state.currentUser.user.autorisation)"></EmargementTrainer>
    </div>
</template>
<script>
import Emargement from "../component/Emargement.vue";
import EmargementTrainer from "../component/EmargementTrainer.vue";
export default {
  name: "Settings",
  components: {
    Emargement,
    EmargementTrainer
  },
  data() {
    return {
    };
  },
};
</script>